import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf75d140"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scroll-up__wrapper" }
const _hoisted_2 = { class: "scroll-up__wrapper__inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scroll-up__background" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "scroll-up__background__inner",
    viewBox: "0 0 48 48"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "48",
      height: "48"
    })
  ])
], -1))
const _hoisted_4 = { class: "scroll-up--icon" }

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollUp',
  setup(__props) {

const root = ref<HTMLElement | null>(null);
 
const onClick = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

return (_ctx: any,_cache: any) => {
  const _component_ui_icon = _resolveComponent("ui-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "scroll-up",
        onClick: onClick,
        ref_key: "root",
        ref: root
      }, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_ui_icon, { name: "arrow-up" })
        ])
      ], 512)
    ])
  ]))
}
}

})